import { reportTelemetryEvent } from '../report';
import { AnalyticsV2EventProps, createAnalyticsV2Event } from '../report/protobuf/createAnalyticsV2Event';

export type ReportUsage = (options: AnalyticsV2EventProps) => void;
export const reportUsageV2: ReportUsage = async (options) => {
  const analyticsV2Event = await createAnalyticsV2Event(options);

  if (!analyticsV2Event) {
    return;
  }

  reportTelemetryEvent(analyticsV2Event);
};
